var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* tslint:disable: class-name */
/*
 * AUTOGENERATED FILE - DO NOT EDIT
 */
import { ewJSONWhoamiSuccess } from './ewJSONWhoamiSuccess';
import { ewRestHandlerPossibleLogin } from './ewRestHandlerPossibleLogin';
import { JSONStruct, nullable, nullable_array_property, property } from 'badphraim/data/JSONStruct';
export class ewRestPortalLoginResourceHandler_RESULT extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.result = '';
    }
}
__decorate([
    nullable_array_property(ewRestHandlerPossibleLogin),
    __metadata("design:type", Array)
], ewRestPortalLoginResourceHandler_RESULT.prototype, "alternative_logins", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestPortalLoginResourceHandler_RESULT.prototype, "result", void 0);
__decorate([
    nullable,
    __metadata("design:type", ewJSONWhoamiSuccess)
], ewRestPortalLoginResourceHandler_RESULT.prototype, "whoami", void 0);
